import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { SectionHeading } from "@/components/Section";
import { Loader2 } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState(null);
  const [cats, setCats] = useState([]);
  const [active, setActive] = useState("all");

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([]));
    api.get("/blog-categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);

  const filtered = posts?.filter((p) => active === "all" || p.category === active) || [];

  return (
    <div className="section-lux grid-glow">
      <div className="container-lux">
        <SectionHeading label="Blog" title="Insights & Growth Strategies" subtitle="Practical marketing insights from the ADNEXA DIGITAL team." />
        <div className="mt-10 flex flex-wrap justify-center gap-2">
          <button onClick={() => setActive("all")} className={`px-4 py-2 rounded-full text-sm font-medium ${active === "all" ? "bg-gradient-to-r from-amber-400 to-amber-600 text-black" : "border border-amber-500/20 text-slate-300"}`}>All</button>
          {cats.map((c) => (
            <button key={c} onClick={() => setActive(c)} className={`px-4 py-2 rounded-full text-sm font-medium ${active === c ? "bg-gradient-to-r from-amber-400 to-amber-600 text-black" : "border border-amber-500/20 text-slate-300"}`}>{c}</button>
          ))}
        </div>
        {posts === null ? (
          <div className="flex justify-center py-20"><Loader2 className="animate-spin text-amber-400" size={36} /></div>
        ) : filtered.length === 0 ? (
          <p className="text-center text-slate-400 mt-16">No articles yet.</p>
        ) : (
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((p, i) => (
              <Link key={p.id} to={`/blog/${p.slug}`} className="card-lux overflow-hidden fade-up" style={{ animationDelay: `${i * 60}ms` }} data-testid={`blog-card-${p.slug}`}>
                {p.featured_image && <img src={p.featured_image} alt={p.title} className="h-48 w-full object-cover" />}
                <div className="p-6">
                  <div className="label-lux mb-2">{p.category}</div>
                  <h3 className="font-semibold text-white line-clamp-2">{p.title}</h3>
                  <p className="text-sm text-slate-400 mt-2 line-clamp-3">{p.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
